import { computed } from 'vue';
import { useDeferred, type UseDeferredReturn } from './useDeferred';
import { prepareTokenDeferred, planDeferred } from '../utils/account';
import type Passport from '@patsnap-utils/passport/src/passport';

// 响应式获取passport
export function usePrepareToken(): UseDeferredReturn<Passport> {
    return useDeferred(prepareTokenDeferred);
}

// 响应式获取登录状态
export function useUserLogin() {
    const { value: prepareToken, isLoading } = usePrepareToken();

    const isLoggedIn = computed(() => {
        return !!prepareToken.value;
    });

    return {
        isLoggedIn,
        isLoading,
    };
}

// 响应式获取用户版本信息
export function usePlan(): UseDeferredReturn<{ isFreemium: boolean; isPersonal: boolean }> {
    return useDeferred(planDeferred);
}
